/*
const myAction = createAction('MY_ACTION', action => {
  return (arg: number) => action(arg);
});
*/

import { createAction } from '../../utils/reduxUtils';
import { IFirebaseUser, IPrivateUser, IUserTranslation } from '../../models';
import { IAsyncError } from '../../common';
import { Area } from '../../services';

type PendingRequest<T> = {
  val: T;
  done: () => void;
};

type UploadImageRequest = {
  imageSrc: string;
  area: Area;
  mimeType: string;
};

type UserTranslationRequest = {
  field: keyof IUserTranslation;
  value: string;
  language: string;
};

const updateUsername = {
  request: createAction('@profile/UPDATE_USERNAME_REQUEST')<string>,
  success: createAction('@profile/UPDATE_USERNAME_SUCCESS')<IFirebaseUser>,
  failure: createAction('@profile/UPDATE_USERNAME_FAILURE')<IAsyncError>,
};

const updateEmail = {
  request: createAction('@profile/UPDATE_EMAIL_REQUEST')<PendingRequest<string>>,
  success: createAction('@profile/UPDATE_EMAIL_SUCCESS')<IFirebaseUser>,
  failure: createAction('@profile/UPDATE_EMAIL_FAILURE')<IAsyncError>,
};

const updatePassword = {
  request: createAction('@profile/UPDATE_PASSWORD_REQUEST')<PendingRequest<string>>,
  success: createAction('@profile/UPDATE_PASSWORD_SUCCESS')<void>,
  failure: createAction('@profile/UPDATE_PASSWORD_FAILURE')<IAsyncError>,
};

const updateImage = {
  request: createAction('@profile/UPDATE_IMAGE_REQUEST')<PendingRequest<UploadImageRequest>>,
  success: createAction('@profile/UPDATE_IMAGE_SUCCESS')<string>,
  failure: createAction('@profile/UPDATE_IMAGE_FAILURE')<IAsyncError>,
};

const fetchPrivateUser = {
  request: createAction('@profile/FETCH_PRIVATE_USER_REQUEST')<void>,
  success: createAction('@profile/FETCH_PRIVATE_USER_SUCCESS')<IPrivateUser>,
  failure: createAction('@profile/FETCH_PRIVATE_USER_FAILURE')<IAsyncError>,
};

const deleteProfile = {
  request: createAction('@profile/DELETE_PROFILE_REQUEST')<void>,
  success: createAction('@profile/DELETE_PROFILE_SUCCESS')<void>,
  failure: createAction('@profile/DELETE_PROFILE_FAILURE')<IAsyncError>,
  cancel: createAction('@profile/DELETE_PROFILE_CANCEL')<void>,
};

const updateUserTranslation = createAction('@profile/UPDATE_USER_TRANSLATION')<UserTranslationRequest>;

const updateWebsite = createAction('@profile/UPDATE_WEBSITE')<string>;

const updatePrivateUser = {
  request: createAction('@profile/UPDATE_PRIVATE_USER_REQUEST')<void>,
  success: createAction('@profile/UPDATE_PRIVATE_USER_SUCCESS')<IPrivateUser>,
  failure: createAction('@profile/UPDATE_PRIVATE_USER_FAILURE')<IAsyncError>,
};

const showReauthenticationDialog = createAction('@profile/SHOW_REAUTHENTICATION_DIALOG')<() => void>;

const actions = {
  updateUsername,
  updateEmail,
  updatePassword,
  updateImage,
  updateUserTranslation,
  updateWebsite,
  updatePrivateUser,
  fetchPrivateUser,
  deleteProfile,
  showReauthenticationDialog,
};

export default actions;
